import { EnvironmentModel } from 'shared/interfaces/environment.interface';

const domain = 'dev-content.shijicloud.com';
//const domain = 'ch-featuredev.iceportal.com';

export const environment: EnvironmentModel = {
    name: 'dev',
    production: false,
    dev: true,
    BASE_URL: `https://${domain}/`,
    usersGraphQLURL: `https://${domain}/userApi/graphql`,
    listingGraphQLURL: `https://${domain}/listingApi/graphql`,
    suppliersGraphQLURL: `https://${domain}/supplierManagementApi/graphql`,
    distributionManagementGraphQLURL: `https://${domain}/distributionManagementApi/graphql`,
    maxBulkEditableListings: 1000,
    iceDashboardUrl: 'https://ppe.iceportal.com/dashboardapi',
    featureFlags: {
        contentVisualsSplit: true,
        monitoringTab: true,
        restrictiveUi: true,
        checkForDuplicatedAssets: true,
        replaceAsset: true,
        visualsDashboard: true,
        listingChannelComparison: true,
        listingChannelComparisonLogs: true,
        visualsCategoryCoverage: true,
        visualsImageTracker: true,
        visualsCustomContent: true,
        unifiedListing: true,
        aiSpendingLimits: true,
    },
};
